import { AdvancedSearchService } from './services/advanced-search.service';
import { AttachmentService } from "@ispm/migration/services/attachment.service";
import { DiagnosticOrderService } from "@ispm/test/services/diagnostic-order.service";
import { GenomeViewerService } from './services/genome-viewer.service';
import { PathologistComponent } from "@ispm/migration/components/pathologist/pathologist";
import { IgvComponent } from "./test/components/igv/igv.component";

export const DashboardComponents = [
  IgvComponent,
  PathologistComponent
];

export const  DashboardServices = [
  AdvancedSearchService,
  AttachmentService,
  DiagnosticOrderService,
  GenomeViewerService,
];
